module.exports = __webpack_public_path__ + "img/ad_5.8aa38141.png";